// extracted by mini-css-extract-plugin
module.exports = {"classes":"\"../../../../themes/theme.module.css\"","grey450":"#BDBDBD","userAvatar":"JDPAvatar_userAvatar__2LGaS"};